import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

class FacebookPostComponent extends Component {
  constructor(props) {
    super(props);
    const { post } = this.props;
    this.state = {
      post,
    };
  }

  componentDidMount() {
    const { accessToken, post: pPost } = this.props;
    const { ID } = pPost;
    const url = `https://graph.facebook.com/${ID}?fields=object_id,likes,shares,comments&access_token=${accessToken}`;
    axios.get(url).then((promise) => {
      const { data } = promise;
      const objId = data.object_id;
      const { post: sPost } = this.state;
      sPost.Photo = objId ? `https://graph.facebook.com/${objId}/picture` : '';
      sPost.Likes = data.likes ? data.likes.data.length : 0;
      sPost.Shares = data.shares ? data.shares.count : 0;
      sPost.Comments = data.comments ? data.comments.data.length : 0;
      this.setState({ post: sPost });
    });
  }

  render() {
    const { highlight } = this.props;
    const { post } = this.state;
    const divStyle = {
      backgroundImage: post.Photo ? `url('${post.Photo}')` : '',
    };

    return (
      <a href="https://facebook.com/UniAarhus/">
        <div className="fb-post">
          <div style={divStyle} />
          {/* eslint-disable-next-line react/no-danger */}
          <div dangerouslySetInnerHTML={{ __html: `<p>${highlight(post.Message.substring(0, 240), 'https://facebook.com/')}...</p>` }} />
          <div className="stats">
            <span className="likes">{post.Likes}</span>
            <span className="comments">{post.Comments}</span>
            <span className="shares">{post.Shares}</span>
          </div>
        </div>
      </a>
    );
  }
}

FacebookPostComponent.propTypes = {
  post: PropTypes.shape({
    Comments: PropTypes.number.isRequired,
    Created: PropTypes.string.isRequired,
    ID: PropTypes.string.isRequired,
    Likes: PropTypes.number.isRequired,
    Message: PropTypes.string.isRequired,
    Photo: PropTypes.string,
    Shares: PropTypes.number.isRequired,
  }).isRequired,
  accessToken: PropTypes.string.isRequired,
  highlight: PropTypes.func.isRequired,
};

FacebookPostComponent.displayName = 'FacebookPostComponent';
export default FacebookPostComponent;
